import useIsMobile from '@/hooks/useIsMobile';
import useResetPass from './useResetPass';
import ResetPassDesktop from './desktop';
import ResetPassMobile from './mobile';

function ResetPass() {
  const isMobile = useIsMobile(992);
  const viewModel = useResetPass();

  return isMobile ? <ResetPassMobile viewModel={viewModel} /> : <ResetPassDesktop viewModel={viewModel} />;
}

export default ResetPass;
